"use client";
import React, { useState } from "react";
import dynamic from "next/dynamic";
const FilterDrawer = dynamic(() => import("./FilterDrawer"),{ssr: true});
import Image from "next/image";
import { useDispatch } from "react-redux";
import { setIsFilterOpen as setGlobalFilterOpen } from "@/store/headerSlice";

type Category = "industries" | "projectTypes" | "technologies";

interface Option {
  name: string;
  slug: string;
}

interface FilterProps {
  isChanged: boolean;
  selectedFilters?: Record<Category, Option[]>; // optional for future use
  onFilterChange: (filters: Record<Category, Option[]>) => void;
  availableFilters: Record<Category, Option[]>;
}

const FilterMobile: React.FC< FilterProps> = ({ isChanged,
  selectedFilters,
  availableFilters,
  onFilterChange,
 }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();

  const handleToggle = (val: boolean) => {
    setIsOpen(val);
    dispatch(setGlobalFilterOpen(val));
  };

  const handleApply = (applied: Record<string, string[]>) => {
    handleToggle(false);
    const filter: any = {};
    (Object.keys(availableFilters) as Category[]).forEach(
      (category: Category) => {
        if (applied[category])
          filter[category] = applied[category].map((slug) => {
            return { slug };
          });
      }
    );
    const filters = {
      industries: selectedFilters?.industries ?? [],
      projectTypes: selectedFilters?.projectTypes ?? [],
      technologies: selectedFilters?.technologies ?? [],
    };
    onFilterChange({ ...filters, ...filter });
  };
  return (
    <>
      <div className="container">
        {/* Button to open drawer */}
        <button
          onClick={() => handleToggle(true)}
          className="flex justify-between items-center w-full bg-white border border-border px-[17px] py-5 cursor-pointer -translate-y-full"
        >
          Filter
          <figure
            className={`aspect-square w-[32px] flex justify-center items-center border bg-blue-50 border-border`}
          >
            <Image
              src="/images/filter_alt.svg"
              alt="filter"
              width={20}
              height={20}
            />
          </figure>
        </button>

        {/* Applied filters outside */}
        {/* <div className="mt-4 flex flex-wrap gap-2"> {Object.entries(appliedFilters).flatMap(([key, values]) =>
            values.map((v) => (<span key={`${key}-${v}`} className="px-2 py-1 bg-green-500 text-white rounded text-xs">{v}</span>)))}</div> */}

        {/* Drawer */}
        <FilterDrawer
          isOpen={isOpen}
          isChanged={isChanged}
          onApply={handleApply}
          onClose={() => handleToggle(false)}
          selectedFilters={selectedFilters}
          availableFilters={availableFilters}
        />
      </div>
    </>
  );
};
export default FilterMobile;
